import PropTypes from 'prop-types'

const LayoutOverview = (props) => {
  return (
    <>
      <div className="LayoutOverview">
        <div className="LayoutOverview-inner">
          <div className="LayoutOverview-header">{props.headerContent}</div>
          <div className="LayoutOverview-main">
            <div className="LayoutOverview-mainFilter">{props.filterContent}</div>
            <div className="LayoutOverview-mainContent">{props.mainContent}</div>
          </div>
        </div>
      </div>
    </>
  )
}

LayoutOverview.propTypes = {
  headerContent: PropTypes.shape({}),
  filterContent: PropTypes.shape({}),
  mainContent: PropTypes.any
}

export default LayoutOverview
